import { StatisticalAnalysisTimesheetItems } from '@/modules/statistical-analysis-module/shared/services/statistical-analysis-timesheet/statistical-analysis-timesheet.dto'
import axios from 'axios'

class StatisticalAnalysisTimesheetService {
    async getTimesheets(): Promise<StatisticalAnalysisTimesheetItems[]> {
        const response = await axios.get<StatisticalAnalysisTimesheetItems[]>(`/statisticAnalysis/timeSheet`)
        return response.data
    }
}

export const statisticalAnalysisTimesheetService = new StatisticalAnalysisTimesheetService()
